<template>
  <div
    class="modal fade"
    id="walletInfoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="walletInfoModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-body p-0">
          <!-- Header com gradiente -->
          <div
            class="p-5 text-center position-relative overflow-hidden"
            style="
              background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
            "
          >
            <div class="position-relative z-index-1">
              <div class="icon-box mb-3 mx-auto">
                <i class="material-icons text-white" style="font-size: 3.5rem"
                  >account_balance_wallet</i
                >
              </div>
              <h3 class="text-white font-weight-bolder mb-2">
                Bem-vindo à Carteira!
              </h3>
              <p class="text-white opacity-8 mb-0">
                Descubra como nossa Carteira do Sistema pode facilitar sua vida
              </p>
            </div>
          </div>

          <!-- Conteúdo -->
          <div class="p-5">
            <!-- O que é -->
            <div class="mb-4">
              <div class="d-flex align-items-start mb-3">
                <div
                  class="icon-circle bg-gradient-primary me-3"
                  style="min-width: 48px"
                >
                  <i class="material-icons text-white">info</i>
                </div>
                <div>
                  <h6 class="font-weight-bold mb-2">
                    O que é a Carteira do Sistema?
                  </h6>
                  <p class="text-sm text-muted mb-0">
                    É um sistema integrado de pagamentos que permite você
                    gerenciar suas campanhas e recebimentos de forma
                    simplificada, tudo em um só lugar.
                  </p>
                </div>
              </div>
            </div>

            <!-- Benefícios -->
            <div class="mb-4">
              <h6 class="font-weight-bold mb-3 text-dark">
                <i class="material-icons text-success align-middle me-2"
                  >check_circle</i
                >
                Principais Benefícios:
              </h6>

              <div class="benefit-item">
                <div class="benefit-icon bg-gradient-success">
                  <i class="material-icons">card_giftcard</i>
                </div>
                <div>
                  <strong>Campanhas Gratuitas</strong>
                  <p class="text-sm text-muted mb-0">
                    Crie quantas campanhas quiser sem pagar nada adiantado.
                  </p>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon bg-gradient-info">
                  <i class="material-icons">trending_up</i>
                </div>
                <div>
                  <strong>Pague Apenas Quando Vender</strong>
                  <p class="text-sm text-muted mb-0">
                    Você só é cobrado quando realmente vender suas campanhas.
                    Sem riscos!
                  </p>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon bg-gradient-warning">
                  <i class="material-icons">account_balance</i>
                </div>
                <div>
                  <strong>Carteira Integrada</strong>
                  <p class="text-sm text-muted mb-0">
                    Acompanhe seu saldo, transações e solicite saques
                    diretamente pelo sistema.
                  </p>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon bg-gradient-danger">
                  <i class="material-icons">speed</i>
                </div>
                <div>
                  <strong>Gestão Simplificada</strong>
                  <p class="text-sm text-muted mb-0">
                    Tudo em um só lugar: crie, venda e receba com facilidade.
                  </p>
                </div>
              </div>
            </div>

            <!-- Nota sobre desativação -->
            <div class="alert alert-light border mb-4">
              <div class="d-flex align-items-start">
                <i class="material-icons text-warning me-2">lightbulb</i>
                <div class="text-sm">
                  <strong>Quer desativar depois?</strong> Sem problemas! Basta
                  entrar em contato conosco e faremos a desativação para você.
                </div>
              </div>
            </div>

            <!-- Botões de ação -->
            <div class="d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn btn-outline-secondary font-weight-bold"
                @click="closeModal"
              >
                Entendi
              </button>
              <router-link
                to="/wallet/application"
                class="btn btn-primary font-weight-bolder shadow-sm px-4 d-inline-flex align-items-center justify-content-center"
                style="
                  background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
                  border: none;
                  margin: 0;
                  color: white;
                "
                @click="closeModal"
              >
                <i
                  class="material-icons align-middle me-1"
                  style="font-size: 1.2rem"
                  >arrow_forward</i
                >
                Solicitar Ativação
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "WalletInfoModal",
  emits: ["close", "activate"],
  data() {
    return {
      modalInstance: null,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal, {
      backdrop: "static",
      keyboard: true,
    });
  },
  methods: {
    show() {
      this.modalInstance.show();
    },
    closeModal() {
      this.modalInstance.hide();
      this.$emit("close");
    },
    activateWallet() {
      this.modalInstance.hide();
      this.$emit("activate");
    },
  },
};
</script>

<style scoped>
.icon-box {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.benefit-item {
  display: flex;
  align-items: start;
  gap: 1rem;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 10px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.benefit-item:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.benefit-icon {
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.benefit-icon i {
  font-size: 1.25rem;
}

.gap-2 {
  gap: 0.5rem;
}
</style>
